import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import { app } from './main';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageKey: 0,
    user: JSON.parse(localStorage.getItem('user')),
    isAuthorized: !!localStorage.getItem('access-token') && !!localStorage.getItem('user'),
  },
  mutations: {
    refreshTable(state) {
      state.pageKey++;
    },
    logIn(state, payload) {
      state.isAuthorized = true;
      state.user = payload;

      localStorage.setItem('user', JSON.stringify(payload));

      if (app.$route.query.from) {
        app.$router.push(app.$route.query.from);
      } else {
        app.$router.push('/freight-orders');
      }
    },
    setUser(state, payload) {
      state.user = payload;
      localStorage.setItem('user', JSON.stringify(payload));
    },
    logOut(state, pathname) {
      state.isAuthorized = false;
      state.user = null;

      if (pathname) {
        router.push(`/sign-in?from=${pathname}`);
      } else {
        router.push('/sign-in');
      }

      localStorage.removeItem('user');
      localStorage.removeItem('access-token');
      localStorage.removeItem('refresh-token');
    },
  },
});
